import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import MainLayout from './components/Layout/MainLayout';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Orders from './pages/Orders';
import Customers from './pages/Customers';
import UserManagement from './pages/UserManagement';
import Categories from './pages/Categories';
import Profile from './pages/Profile';
import Subcriber from './pages/Subcriber';
import SuperAdminUserManagement from './pages/SuperAdminUserManagement';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return null; // Or a loading spinner
  }

  return user && user.isAuthenticated ? children : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  return user && user.isAuthenticated ? <Navigate to="/dashboard" /> : children;
};

const AuthRedirect = () => {
  const { user } = useAuth();
  return user && user.isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />;
};

function App() {

  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><MainLayout><Dashboard /></MainLayout></PrivateRoute>} />
          <Route path="/products" element={<PrivateRoute><MainLayout><Products /></MainLayout></PrivateRoute>} />
          <Route path="/categories" element={<PrivateRoute><MainLayout><Categories /></MainLayout></PrivateRoute>} />
          <Route path="/orders" element={<PrivateRoute><MainLayout><Orders /></MainLayout></PrivateRoute>} />
          <Route path="/customers" element={<PrivateRoute><MainLayout><Customers /></MainLayout></PrivateRoute>} />
          <Route path="/users" element={<PrivateRoute><MainLayout><UserManagement /></MainLayout></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><MainLayout><Profile /></MainLayout></PrivateRoute>} />
          <Route path="/subcriber" element={<PrivateRoute><MainLayout><Subcriber /></MainLayout></PrivateRoute>} />
          <Route path="/super-admin/users" element={<PrivateRoute><MainLayout><SuperAdminUserManagement /></MainLayout></PrivateRoute>} />
          <Route path="/" element={<AuthRedirect />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;